export type FormStepProductsEndpoints = 'verifyMainComponent' | 'verifySubComponent';

export const endpointStub = 'path:/m-formstep-warranty-wolf/';
export const endpoint: Record<FormStepProductsEndpoints, string> = {
	verifyMainComponent: 'verifyMainComponent',
	verifySubComponent: 'verifySubComponent'
}

